























































































import { Vue, Component, Prop } from 'vue-property-decorator'
import PopupState from './popup-state.vue'
import appInfo from './appInfo'

@Component({
  name: 'PopupAppInfo',
  components: {
    PopupState
  }
})
export default class extends Vue {
  @Prop({ required: true })
  info!: object

  appInfo = Object.freeze(appInfo)
}
